module.exports = __webpack_public_path__ + "static/media/Newprojecttype.08de2a0d.svg";